import React from 'react';

import Skeleton from '../../../../Skeleton';

export default {
  performanceSnapshot: <Skeleton height={122} width="100%" />,
};
